import { render } from "./NewLoaderComponent.vue?vue&type=template&id=475871e4&scoped=true"
import script from "./NewLoaderComponent.vue?vue&type=script&lang=js"
export * from "./NewLoaderComponent.vue?vue&type=script&lang=js"

import "./NewLoaderComponent.vue?vue&type=style&index=0&id=475871e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475871e4"]])

export default __exports__